const globales = {
    methods: {
        isChrome() {
            return ((navigator.userAgent.toLowerCase().indexOf('chrome') > -1) && (navigator.vendor.toLowerCase().indexOf("google") > -1));
        },
        imgExtension() {
            return this.isChrome() ? '.webp' : '.jpg'
        },
        usuarioGlobal() {
            let lsToken = this.lsTokenDifarmer();
            let user = JSON.parse(lsToken.user)
            //let user = JSON.parse(window.localStorage.user)
            return user
        },
        lsTokenDifarmer() {
            let lsToken = JSON.parse(window.localStorage.tokenDifarmer);
            return lsToken;
        },
        soloConsulta() {
            let tokenDifarmer = this.lsTokenDifarmer();
            let soloConsulta = JSON.parse(tokenDifarmer.soloConsulta)
            return soloConsulta;
        }
    }
}

export default globales